import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

type RequireAdminProps = {
  children: ReactNode;
};

const RequireAdmin = ({ children }: RequireAdminProps) => {
  const { user, userManagementEnabled } = useAuth();
  const location = useLocation();

  if (!userManagementEnabled) {
    if (location.pathname === "/users" || location.pathname === "/usergroups") {
      return <Navigate to="/player" replace />;
    }
    return <>{children}</>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (user.role !== "admin") {
    return <Navigate to="/player" replace />;
  }

  return <>{children}</>;
};

export default RequireAdmin;
